import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import Module from "../Module";
export default store => ({
  path: "explore",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "toddle-academy" */ "./components"),
      ]).then(([importedModule0]) => {
        const component = importedModule0.default;
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [Module(store)],
});
